import type { FaireProductEntity } from "../../entity_types/product";

export const p_duh7pwrdqj: FaireProductEntity = {
  token: "p_duh7pwrdqj",
  type: "product",
  name: "Ladies Fully Beaded EVIL EYE Theme Fashion Coin Purse",
  brandToken: "b_eungak2r99",
  brandName: "Nima Accessories Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/af3caadbacd8820b56868bc68ec3e40a3af7fab374ae83eb296f7ce6e14fdccd.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.01,
  description: "",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:52.343Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
